/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import WaveSurfer from 'wavesurfer.js';
import { WaveSurferParams } from "wavesurfer.js/types/params";

export interface WebFormProps {
  url: string;
  playing: boolean;
  height?: number;
  waveColor?: string;
  cursorColor?: string;
  progressColor?: string;
  onPlay?: () => void;
  onPause?: () => void;
  onFinish?: () => void;
  onPlaying?: (second: number) => void;
}

export const Waveform: React.FC<WebFormProps> = (props) => {
  const waveSurferRef = useRef<WaveSurfer>(null);
  const wavesurfer = useRef<WaveSurfer>(null);
  const [volume, setVolume] = useState(0.5);
  const [audio,] = useState<string>(props.url);

  const {
    playing = false,
    height = 70,
    waveColor = '#DDE9F4',
    cursorColor = '#00cbd8',
    progressColor = '#037A9A',
    onFinish,
    onPause,
    onPlay,
    onPlaying
  } = props;

  const formWaveSurferOptions = (element: WaveSurfer): WaveSurferParams => {
    return {
      container: element as any as HTMLElement,
      responsive: true,
      barWidth: 3,
      // cursorWidth: 0,
      height: height,

      waveColor: waveColor,
      cursorColor: cursorColor,
      progressColor: progressColor,
      // cursorWidth: 0,
      hideCursor: true,
      normalize: true,
      partialRender: true,
      barGap: 2,
    }
  };

  useEffect(() => {
    if (waveSurferRef.current) {
      const options = formWaveSurferOptions(waveSurferRef.current);
      // @ts-ignore
      wavesurfer.current = WaveSurfer.create(options);
      wavesurfer.current.load(audio);
      wavesurfer.current.autoplay = false;
      wavesurfer.current.on('ready', () => {
        if (wavesurfer.current) {
          wavesurfer.current.setVolume(volume);
          setVolume(volume);
        }
      })

      wavesurfer.current.on('play', () => {
        if (onPlay && playing === false) onPlay();
      })
      wavesurfer.current.on('pause', () => {
        if (onPause) onPause();
      })
      wavesurfer.current.on('finish', () => {
        if (onFinish) onFinish();
      })
      wavesurfer.current.on('audioprocess', (e) => {
        if (onPlaying) onPlaying(e);
      })
      return () => {
        wavesurfer?.current?.destroy();
      }
    }
  }, [audio]);

  const onChangePlayingStatus = () => {
    if (playing) wavesurfer?.current?.play();
    else wavesurfer?.current?.playPause();
  }

  useEffect(onChangePlayingStatus, [])

  useEffect(onChangePlayingStatus, [playing]);

  return (
    <div className="track-waveform-component" ref={waveSurferRef as any as React.RefObject<HTMLDivElement>} />
  );
};

export default Waveform;